import http from './base/http';

const SERVICE_ID = '12016';

//  基础结算方式查询
export function getBasicSettlementMode() {
  const params = {
    SERVICE_ID,
    OTYPE: 1,
  };
  return http.post(params);
}

//  团餐结算方式查询
export function getTCSettlementMode() {
  const params = {
    SERVICE_ID,
    OTYPE: 4,
    TC_ID: Number(sessionStorage.getItem('companyId')),
  };
  return http.post(params);
}
// 团餐结算方式修改类型
export function changeTCSettlementModeType(data) {
  /**
   * @param {Number}  TC_SETTLEMENT_ID  团餐公司结算方式ID,必传
   * @param {Number}  SETTLEMENT_TYPE   结算类型：0，默认；1管理费；2餐费；3送货单,必传
   */
  const params = {
    SERVICE_ID,
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// 重新配置团餐公司选择的结算方式
export function configureTCSelectedSettlementMode(data) {
  /**
   * @param {Number}  TC_SETTLEMENT_INFO[0].SETTLEMENT_ID     结算模式ID,必传
   * @param {Number}  TC_SETTLEMENT_INFO[0].SETTLEMENT_NAME   结算模式名称,必传
   * @param {Number}  TC_SETTLEMENT_INFO[0].SETTLEMENT_TYPE   结算类型：0，默认；1管理费；2餐费；3送货单,必传
   */
  const params = {
    SERVICE_ID,
    OTYPE: 6,
    TC_ID: Number(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/settlementModeManagement.js